import styled from 'styled-components';
import { Typography } from '@material-ui/core';

export const SectionTitle = styled(Typography)`
    margin-bottom: ${({ theme }) => `${theme.spacing(2)}px`};
    color: ${({ theme }) => theme.palette.primary.dark};
    font-weight: 700;
    opacity: 0.7;
`;
